module.exports = __webpack_public_path__ + "assets/img/about-14.a2ea5971.png";